import {useNavigate} from "react-router-dom";
import {useCallback, useState} from "react";
import {FetchElements, GetCookie} from "../../../../utils/js/request";
import {REQUEST} from "../../../../utils/js/Const";

export const useGetDetailsInformation = () =>{

    const navigate = useNavigate();

    const [detailInformation, setDetailInformation] = useState(null)
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const fetchDetailsInformation = useCallback(async (order_guid) => {

        const accessToken = GetCookie("access_token");

        const url = `${REQUEST}/api/v1/orders/${order_guid}`;
        setLoading(true);
        setError(null);

        FetchElements(
            url,
            "GET",
            (responseData) => {
                setDetailInformation(responseData);
                setLoading(false);
            },
            navigate,
            2,
            () => {},
            (title, message, statusCode) => {
                const errorObj = {title, message, statusCode};
                console.error(`${title}: ${message}`);
                setError(errorObj);
                setDetailInformation(null);
                setLoading(false);
            },
            0,
            null,
            [],
            false
        );
    }, [navigate])


    return {
        refetch: fetchDetailsInformation,
        detailInformation,
        loading,
        error,
        fetchDetailsInformation,
    };


}